<template>
	<div class="modal fade" role="dialog" aria-labelledby="datos-compra" aria-hidden="true" data-keyboard="false" data-backdrop="static">
		<div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="datos-compra">
						<i class="material-icons">shopping_cart</i> Datos de compra
					</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<preloader v-if="loading"></preloader>
					<div class="form-row">
						<div class="col-md-12 mb-3">
                            <label for="orden_compra">Orden de compra:</label>
                            <input type="text" id="orden_compra" 
                                class="form-control form-control-sm"
                                placeholder="Ingrese orden de compra"
                                v-model="form.ORDEN_COMPRA"
                                name="orden_compra" 
                                maxlength="50">
                        </div>

                        <div class="col-md-12 mb-3">
                            <label for="numero_factura">Número de factura:</label>
                            <input type="text" id="numero_factura" 
                                class="form-control form-control-sm"
                                placeholder="Ingrese número"
                                v-model="form.NUMERO_FACTURA"
                                name="numero_factura" 
                                maxlength="50">
                        </div>

                        <div class="col-md-12 mb-3">
                            <label for="fecha_pago_programado">Fecha de pago programado:</label>
                            <date-picker 
                                id="fecha_pago_programado" 
                                class="form-control-sm"
                                placeholder="dd-mm-yyyy"
                                v-model="form.FECHA_PAGO_PROGRAMADO"
                                name="fecha_pago_programado"></date-picker>
                        </div>

                        <div class="col-md-12 mb-3">
                            <label for="costo">Costo:</label>
                            <decimal type="text" id="costo" 
                                class="form-control form-control-sm"
                                placeholder="Ingrese costo"
                                v-model="form.COSTO"
                                name="costo" />
                        </div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary" v-on:click.prevent="actualizar">
						Actualizar
					</button>
					<button type="button" class="btn btn-secondary" v-on:click.prevent="closeModal">
						Cancelar
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return {
				loading: false,
				oportunidad: '',

				form: {
					ORDEN_COMPRA: '',
					NUMERO_FACTURA: '',
					FECHA_PAGO_PROGRAMADO: '',
					COSTO: ''
				},
				errors: {}
			}
		},

		mounted(){
			var vm = this;
			$(this.$el).on('shown.bs.modal', function (event) {
				var button = $(event.relatedTarget)
				vm.oportunidad = button.data('oportunidad')
				vm.form.ORDEN_COMPRA = button.data('orden')
				vm.form.NUMERO_FACTURA = button.data('factura')
				vm.form.FECHA_PAGO_PROGRAMADO = button.data('pago')
				vm.form.COSTO = button.data('costo')
			});
		},

		methods: {
			actualizar: function(){
				this.loading = true
				var url = 'api/oportunidades/'+this.oportunidad+'/compras'

				axios.put(url, this.form)
				.then(response => {
					this.$toasted.show('Información actualizada')
					this.cleanFields()
					window.location.href = crm.route.oportunidades.index
				}).catch(error => {
					this.$toasted.show('Error actualizar')
					console.log(error.response)
					if (error.response) {
						if (typeof error.response.data === 'string') {
							this.$toasted.show(error.response.data)
						}
					}
					
				}).then(()=>{
					this.loading = false
				})
			},
			
			cleanFields: function(){
				this.form.oportunidad = ''
				this.form.ORDEN_COMPRA = ''
				this.form.NUMERO_FACTURA = ''
				this.form.FECHA_PAGO_PROGRAMADO = ''
				this.form.COSTO = ''
			},

			closeModal: function(){
				$(this.$el).modal('hide')
			}
		}
	}
</script>